var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaste(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.55254 3.37769H5.39645C4.82261 3.37769 4.35742 3.82468 4.35742 4.37607V8.36961C4.35742 8.921 4.82261 9.36799 5.39645 9.36799H9.55254C10.1264 9.36799 10.5916 8.921 10.5916 8.36961V4.37607C10.5916 3.82468 10.1264 3.37769 9.55254 3.37769Z",
    stroke: "#97A1C2",
    strokeWidth: 0.745446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68774 0.382812H7.99426C8.26982 0.382813 8.5341 0.487999 8.72896 0.675232C8.92381 0.862466 9.03328 1.11641 9.03328 1.3812V3.37797",
    stroke: "#97A1C2",
    strokeWidth: 0.745446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.92114 0.382812H5.91607",
    stroke: "#97A1C2",
    strokeWidth: 0.745446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.720947 1.83047V1.3812C0.720947 1.11641 0.830416 0.862466 1.02527 0.675232C1.22013 0.487999 1.4844 0.382813 1.75997 0.382812H2.27948",
    stroke: "#97A1C2",
    strokeWidth: 0.745446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.720947 5.3745V3.48755",
    stroke: "#97A1C2",
    strokeWidth: 0.745446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65353 8.36989H1.75997C1.4844 8.36989 1.22013 8.2647 1.02527 8.07747C0.830415 7.89024 0.720947 7.63629 0.720947 7.37151V6.87231",
    stroke: "#97A1C2",
    strokeWidth: 0.745446,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaste);
export default __webpack_public_path__ + "static/media/paste.397521deaf98e3dec5a37b4ea72e080d.svg";
export { ForwardRef as ReactComponent };